// @ts-nocheck



import React, { Component } from 'react';
import Button from 'antd/lib/button';
import qs from 'query-string';
import { Link } from '../../../lib/routerAdapter';
import notification from 'antd/lib/notification';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';






import { Section } from './../../../components/layout';
import { Popconfirm, Table, Icon, ButtonsRow } from './../../../components/ui';
import { notificationLoading } from './../../../components/Notifications';
import Header from './../../../components/layout/Header';
import {
  getListInitialState,
  setQueryParams,
  formatDateTimeToString,
  navigate,
  toLocalStringRu } from
'./../../../lib/helpers';
import { driverInspectionApi } from './../../../lib/api';
import { withUserAccess } from './../../withUserAccess';


import { setFilter } from '../../../ducks/persistFilters';


import { canHandleService, ACT_COLUMNS } from '../lib';

import DriverInspectionFilter from './Filter';













export const COLUMNS = [
{
  title: 'Период оказания',
  width: '150',
  render: (record) => {
    return `${formatDateTimeToString(
      record.startDate,
      'DD.MM.YYYY'
    )} - ${formatDateTimeToString(record.endDate, 'DD.MM.YYYY')}`;
  }
},
{
  title: 'Сумма оплаты в руб. без НДС',
  dataIndex: 'paymentAmount',
  render: (payment) => `${toLocalStringRu(payment || 0)}`
}];


export class List extends Component {
  static defaultProps = {
    location: {}
  };
  state = {
    ...getListInitialState(),
    filterPath: window.location.pathname
  };
  columns = [...COLUMNS, ...ACT_COLUMNS];

  async componentDidMount() {
    const { page, ...filter } = qs.parse(window.location.search);
    if (!isEmpty(filter)) {
      await this.setPersistFilter(filter);
    }
    if (this.canAdd()) {
      this.columns.push({
        stopPropagation: true,
        width: 20,
        dataIndex: 'id',
        render: (id) =>
        <Popconfirm
          title="Вы уверены, что хотите удалить запись?"
          onConfirm={async () => this.deleteDriverInspection(id)}>

            <Icon type="x" />
          </Popconfirm>

      });
    }
    await this.fetchDriverInspectionList(page);
  }

  deleteDriverInspection = async (id) => {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await driverInspectionApi.deleteDriverInspection(id);
      await this.fetchDriverInspectionList(this.state.page);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('deleting');
    }
  };

  fetchDriverInspectionList = async (
  page = 1,
  params = {}) =>
  {
    const { filterPath } = this.state;
    const filter = this.props.persistFilters[filterPath] || {};
    try {
      this.setState({ loading: true });
      const { data, totalCount } =
      await driverInspectionApi.fetchDriverInspections({
        ...filter,
        page,
        ...params
      });
      setQueryParams({ page });
      this.setState({ data, totalCount, page });
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err.message
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  };

  handleRowClick = (id) =>
  navigate(`/services/driver-inspections/${id}`);

  canAdd = () => canHandleService(this.props.userAccess);

  setPersistFilter = async (values) => {
    const { filterPath } = this.state;
    await this.props.setFilter({
      path: filterPath,
      values
    });
  };

  applyFilter = async (filter = {}) => {
    await this.setPersistFilter(filter);
    await this.fetchDriverInspectionList();
  };

  cleanFilter = this.applyFilter;

  handlePrint = async () => {
    try {
      const filter = this.props.persistFilters[this.state.filterPath];
      notificationLoading({
        message: 'Загрузка файла отчета...',
        key: 'print'
      });
      await driverInspectionApi.printReport(filter);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('print');
    }
  };

  render() {
    const { location } = this.props;
    const { data, totalCount, pageSize, page, loading, filterPath } =
    this.state;
    const filter = this.props.persistFilters[filterPath];

    return (
      <>
        <Header
          left={<h1>Мед. осмотры водителей</h1>}
          right={
          <ButtonsRow>
              <Button onClick={this.handlePrint}>Печать</Button>
              {this.canAdd() &&
            <Link to="/services/driver-inspections/new">
                  <Button type="primary" data-cy="add">
                    Создать
                  </Button>
                </Link>
            }
            </ButtonsRow>
          } />

        <Section>
          <DriverInspectionFilter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            fetch={this.fetchDriverInspectionList}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }}
            loading={loading}
            columns={this.columns}
            data={data.map((item) => ({
              ...item,
              key: item.id
            }))} />

        </Section>
      </>);

  }
}

export default connect(
  (state) => ({
    persistFilters: state.persistFilters
  }),
  {
    setFilter
  }
)(withUserAccess(List));
